<script>
  // Shared price display for the CardCollection shell (ADR-0010). One place for
  // the "$X.XX" and Sample-Card "from $X.XX" treatment, used by CardRow and
  // CardTile (review §4). Renders nothing when there's no positive price.
  // CONTEXT.md "Sample Card": the "from" floor marks a representative printing.
  import { formatPrice } from '../../lib/logic/card-collection-logic.js';

  let { price = 0, currencySymbol = '$', isSample = false } = $props();

  const display = $derived(formatPrice(price, currencySymbol));
</script>

{#if display}
  <span class="cc-price" class:sample={isSample}>
    {#if isSample}<span class="from-label">from</span>{/if}{display}
  </span>
{/if}

<style>
  .cc-price {
    font-family: var(--font-sans);
    font-weight: 700;
    color: var(--color-text);
    font-size: 14px;
  }
  .cc-price.sample {
    color: var(--color-text-secondary);
    font-weight: 600;
  }
  .from-label {
    font-size: 10px;
    font-weight: 500;
    color: var(--color-text-tertiary);
    margin-right: 3px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
</style>
